module.exports = __webpack_public_path__ + "static/media/focus-icon-2.36b3e319.png";